import React from 'react';
import { SectionHeader } from '../../primitives/SectionHeader';
import { OptionCard } from '../../cards/OptionCard';
import { ContactCard } from '../../cards/ContactCard';
import { colors, space } from '../../tokens';
import { DraggableElement } from '../../../DraggableElement';
import { InlineEditableText } from '../../../InlineEditableText';

/**
 * AlternativesSection – "Alternativen zur Dachvermietung" auf Page 4.
 * Enthält 2 OptionCards + 1 ContactCard im selben Grid.
 */
export const AlternativesSection = ({ ansprechpartner, telefon, email, content = {}, onTextChange, editMode = false, layoutEditLevel = 'section', dragProps = {} }) => {
  const alternativesText = {
    header: {
      eyebrow: content?.header?.eyebrow || 'Weitere Möglichkeiten',
      headline: content?.header?.headline || 'ALTERNATIVEN ZUR DACHVERMIETUNG',
    },
    option1: {
      title: content?.option1?.title || 'Direktkauf Ihrer Dachfläche',
      description:
        content?.option1?.description ||
        'EN:POWER kauft Ihre Dachfläche direkt - Sie erhalten eine sofortige Einmalzahlung und behalten alle Eigentumsrechte.',
      hint: content?.option1?.hint || 'Maximale Einmalzahlung',
    },
    option2: {
      title: content?.option2?.title || 'Persönliche Beratung',
      description:
        content?.option2?.description ||
        'In einem persönlichen Gespräch analysieren wir gemeinsam, welche Option optimal zu Ihrer Situation passt.',
      hint: content?.option2?.hint || 'Kostenlose Erstberatung',
    },
  };

  return (
    <>
    {layoutEditLevel === 'detail' ? (
      <DraggableElement id="S4-Alternativen-Header" {...dragProps} dragAxis="y">
        <div style={{ padding: `${space.lg}px ${space.xxl}px 0`, background: 'white', flexShrink: 0 }}>
          <SectionHeader
            eyebrow={<InlineEditableText as="span" value={alternativesText.header.eyebrow} editable={editMode} onChange={(value) => onTextChange?.('alternatives.header.eyebrow', value)} />}
            headline={<InlineEditableText as="span" value={alternativesText.header.headline} editable={editMode} onChange={(value) => onTextChange?.('alternatives.header.headline', value)} />}
          />
        </div>
      </DraggableElement>
    ) : (
      <div style={{ padding: `${space.lg}px ${space.xxl}px 0`, background: 'white', flexShrink: 0 }}>
        <SectionHeader
          eyebrow={<InlineEditableText as="span" value={alternativesText.header.eyebrow} editable={editMode} onChange={(value) => onTextChange?.('alternatives.header.eyebrow', value)} />}
          headline={<InlineEditableText as="span" value={alternativesText.header.headline} editable={editMode} onChange={(value) => onTextChange?.('alternatives.header.headline', value)} />}
        />
      </div>
    )}

    <div style={{ padding: `${space.sm + space.xs}px ${space.xxl}px ${space.md + space.xs}px`, background: 'white', flexShrink: 0 }}>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr 210px',
          gap: `${space.md}px`,
          minHeight: '122px',
          alignItems: 'stretch',
          boxSizing: 'border-box',
        }}
      >
        {layoutEditLevel === 'detail' ? (
          <DraggableElement id="S4-Alternative-1" {...dragProps} dragAxis="y" initialStyle={{ height: '100%' }}>
            <OptionCard
              accentColor={colors.orange}
              title={alternativesText.option1.title}
              description={alternativesText.option1.description}
              hint={alternativesText.option1.hint}
            />
          </DraggableElement>
        ) : (
          <div style={{ height: '100%' }}>
            <OptionCard
              accentColor={colors.orange}
              title={alternativesText.option1.title}
              description={alternativesText.option1.description}
              hint={alternativesText.option1.hint}
            />
          </div>
        )}
        {layoutEditLevel === 'detail' ? (
          <DraggableElement id="S4-Alternative-2" {...dragProps} dragAxis="y" initialStyle={{ height: '100%' }}>
            <OptionCard
              accentColor="rgba(18,42,92,0.3)"
              title={alternativesText.option2.title}
              description={alternativesText.option2.description}
              hint={alternativesText.option2.hint}
            />
          </DraggableElement>
        ) : (
          <div style={{ height: '100%' }}>
            <OptionCard
              accentColor="rgba(18,42,92,0.3)"
              title={alternativesText.option2.title}
              description={alternativesText.option2.description}
              hint={alternativesText.option2.hint}
            />
          </div>
        )}
        {layoutEditLevel === 'detail' ? (
          <DraggableElement id="S4-Kontakt" {...dragProps} dragAxis="y" initialStyle={{ height: '100%' }}>
            <ContactCard name={ansprechpartner} telefon={telefon} email={email} />
          </DraggableElement>
        ) : (
          <div style={{ height: '100%' }}>
            <ContactCard name={ansprechpartner} telefon={telefon} email={email} />
          </div>
        )}
      </div>
    </div>

    <div style={{ height: '1px', background: colors.border, flexShrink: 0, margin: `${space.xs}px ${space.xxl}px 0` }} />
    </>
  );
};
